import styled from "@emotion/styled";
import { Affix, Button } from "antd";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

interface FooterTransportationProps {
  loading?: boolean;
}

const FooterTransportation: FC<FooterTransportationProps> = ({ loading }) => {
 const navigate = useNavigate();

  return (
    <Affix offsetBottom={0}>
      <WrapperAll>
        <ButtonWrapper>
          <Button
            htmlType="submit"
            type="primary"
            style={{ width: 200 }}
            size="middle"
            onClick={ ()=> {
              navigate('/manage-transportation/create')
            }}
          >
            เพิ่มขนส่งใหม่
          </Button>
        </ButtonWrapper>
      </WrapperAll>
    </Affix>
  );
};

export default FooterTransportation;
const ButtonWrapper = styled.div`
  max-width: 250px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const WrapperAll = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0px;
  background-color: #fff;
  border-radius: 4px;
`;
